import { Injectable } from '@angular/core';

import { map } from 'rxjs';

import type { AssistantSettingsState } from '@core/intelligence-types';
import { injectTellentIntelligenceHttp } from '@core/tellent-http-legacy';

@Injectable({ providedIn: 'root' })
export class AssistantSettingsHttp {
  private httpApi = injectTellentIntelligenceHttp();

  public fetch() {
    return this.httpApi
      .get('/assistant/settings', null, null)
      .pipe(map((response): AssistantSettingsState => response.data));
  }

  public update(data: Partial<AssistantSettingsState>) {
    return this.httpApi
      .patch('/assistant/settings', null, data)
      .pipe(map((response): AssistantSettingsState => response.data));
  }
}
